<template>
  <div
    class="divider"
    :class="{
      'divider--padded': padded,
      'divider--margin-bottom': marginBottom,
      'divider--white': white,
    }"
  >
    <div
      v-if="$slots.default"
      class="d-text"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    padded: {
      type: Boolean,
    },
    marginBottom: {
      type: Boolean,
    },
    white: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.divider {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  min-height: $pad * 1.375;

  &:after {
    content: '';
    @include center;
    display: block;
    width: 100%;
    height: 1px;
    background-color: palette(sand);
    z-index: 0;
  }

  .d-text {
    background-color: $color-general-background-neutral-default;
    color: $color-general-text-neutral-low;
    padding: 0 $pad;
    z-index: 1;
    font-size: map-get($font-sizes, 'm');
  }

  &.divider--padded {
    min-height: $pad * 4;
  }

  &.divider--margin-bottom {
    margin-bottom: $pad * 0.25;
  }

  &.divider--white:after {
    background-color: $color-general-background-neutral-default;
  }
}
</style>
